import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class OrderPlanningAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  createConfigurationSuccess() {
    const message = {
      body: 'CREATE_ORDER_PLANNING_CONFIGURATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createConfigurationError() {
    const message = {
      body: 'CREATE_ORDER_PLANNING_CONFIGURATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateConfigurationSuccess() {
    const message = {
      body: 'UPDATE_ORDER_PLANNING_CONFIGURATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateConfigurationError() {
    const message = {
      body: 'UPDATE_ORDER_PLANNING_CONFIGURATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  deleteConfigurationSuccess() {
    const message = {
      body: 'DELETE_ORDER_PLANNING_CONFIGURATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteConfigurationError() {
    const message = {
      body: 'DELETE_ORDER_PLANNING_CONFIGURATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  uploadCustomOrdersSuccess() {
    const message = {
      body: 'UPLOAD_CUSTOM_ORDERS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  uploadCustomOrdersWarning() {
    const message = {
      body: 'UPLOAD_CUSTOM_ORDERS_WARNING'
    };
    return this.bringozToastService.warning(message);
  }

  uploadCustomOrdersError() {
    const message = {
      body: 'UPLOAD_CUSTOM_ORDERS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.order-planning-configuration')
  .service('orderPlanningAlertsService', OrderPlanningAlertsService);
